<app-dialog-header [title]="'PAGE.CERTIFICATION_PROVIDER.LABEL.MOVE_TO_ANOTHER'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="w-100-p table-wrapper" [class.hidden]="isLoading">
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="provider">
                <mat-header-cell class="header-cell-30 pl-24" *matHeaderCellDef>
                    <span> {{ 'PAGE.CERTIFICATIONS.LABEL.PROVIDER' | translate }} </span>
                </mat-header-cell>
                <mat-cell class="cell-30 pl-24" *matCellDef="let data">
                    <span [class.opacity-50]="data.status === CertificationProviderStatusEnum.Archived">{{ data.providerName }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data"
                    ><span translate>{{ data.status | getStatusByValue: certificationProviderStatus:'translationLabel' }}</span></mat-cell
                >
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let data">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(data)" [disabled]="selectedProvider" *ngIf="!data.selected"></app-flat-button>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(data)" *ngIf="data.selected"></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator persistPageSize="certification-provider.providers-list-dialog" [length]="certificationProvidersTotalCount$ | async" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
    </div>

    <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
        <div class="shimmer-container min-w-full p-0">
            <div class="shimmer p-12">
                <div class="shimmer-card !max-w-full table h-480 animate"></div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayoutAlign="flex-end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" [disabled]="!selectedProvider" (onClick)="saveSelected()"></app-flat-button>
</div>
